import React, {useEffect, useState} from "react";
import {db} from "../config/firebase-config";
import {addDoc, collection} from "firebase/firestore";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Container} from "react-bootstrap";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Dropdown from "react-bootstrap/Dropdown";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import axios from "axios";
import useAuthorization from "../auth/useAuthorization";
import {
  EMAIL_HINWEIS,
  getrimmteEmailAdresse,
  istGueltigeEmailAdresse,
} from "../utils/emailAdresse";

/**
 * Immer deutsch formatiert, nie über die Locale des Geräts: genau daran ist der
 * Mailversand 14 Monate lang gescheitert (#3).
 */
const alsMeldezeitpunkt = (datum) =>
  datum.toLocaleString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

/**
 * Die Kerndaten des Mangels — im Fehlerzustand der Beleg, dass er gespeichert
 * ist, und die Referenz, die der Melder am Telefon vorliest. Die eigenen
 * Kontaktdaten des Melders stehen nicht dabei: er kennt sie. Die
 * Firestore-Dokument-ID auch nicht — für die Technik nicht nachschlagbar,
 * kryptisch beim Diktieren.
 */
const kerndaten = ({mangel, kennzeichen, kennung}) => ({
  kennzeichen,
  kennung,
  kategorie: mangel.kategorie,
  kilometer: mangel.kilometer,
  gemeldet: alsMeldezeitpunkt(mangel.datumAngelegt),
  beschreibung: mangel.historie[0].beschreibung,
});

/**
 * Die Technik-Hotline: fest im Code statt aus der Konfiguration, weil sie eine
 * fachliche Zusage ist und keine Umgebungsentscheidung — ein fehlender
 * Konfigurationswert dürfte hier keine leere Zeile erzeugen.
 */
const TECHNIK_HOTLINE = {
  anzeige: "0421-36111700",
  waehlbar: "tel:+4942136111700",
};

const ModalMangel = (props) => {
  const {canWrite, isAuthenticated} = useAuthorization();
  const canCreateMangel = !isAuthenticated || canWrite;
  const today = new Date();

  const [kategorie, setKategorie] = useState("");
  const [kontaktVorname, setKontaktVorname] = useState("");
  const [kontaktNachname, setKontaktNachname] = useState("");
  const [kontaktEmail, setKontaktEmail] = useState("");
  const [kontaktTelefon, setKontaktTelefon] = useState("");
  const [kilometer, setKilometer] = useState("");
  const [beschreibung, setBeschreibung] = useState("");
  const [fahrzeugId, setFahrzeugId] = useState("");
  const [kennzeichenList, setKennzeichenList] = useState([]);
  const [checkDatenschutz, setCheckDatenschutz] = useState(false);
  // Erst wenn der Melder das E-Mail-Feld einmal verlassen hat, darf der Hinweis
  // erscheinen — sonst wäre jede halbfertige Eingabe rot.
  const [emailBeruehrt, setEmailBeruehrt] = useState(false);
  const [istAmSenden, setIstAmSenden] = useState(false);
  // Gesetzt, sobald der Mangel steht, die Benachrichtigung aber nicht raus ist:
  // trägt den Stand der Meldung in den Fehlerzustand und schaltet ihn ein.
  const [gescheiterteMeldung, setGescheiterteMeldung] = useState(null);

  useEffect(() => {
    let tmp = [];
    for (let i = 0; i < props.fahrzeuge.length; i++) {
      tmp.push({
        kennzeichen: props.fahrzeuge[i].kennzeichen,
        id: props.fahrzeuge[i].id,
      });
    }

    tmp.sort((a, b) =>
      a.kennzeichen > b.kennzeichen
        ? 1
        : b.kennzeichen > a.kennzeichen
          ? -1
          : 0,
    );

    setKennzeichenList(tmp);
  }, [props.fahrzeuge]);

  // Kennzeichen, Funkkennung und deren Verteiler-Adresse folgen zwingend aus
  // dem gewählten Fahrzeug — abgeleitet statt über einen Effekt in Zustände
  // gespiegelt, damit sie nie eine Auswahl hinterherhinken.
  const gewaehltesFahrzeug = props.fahrzeuge.find(
    (eintrag) => eintrag.id === fahrzeugId,
  );
  const kennzeichen = gewaehltesFahrzeug ? gewaehltesFahrzeug.kennzeichen : "";
  const kennung = gewaehltesFahrzeug ? gewaehltesFahrzeug.funkkennung : "";
  const zustaendigeKennung = props.funkkennungen.find(
    (eintrag) => eintrag.bezeichnung === kennung,
  );
  const kennungEmail = zustaendigeKennung
    ? zustaendigeKennung.kontaktEmail
    : "";

  const emailAdresse = getrimmteEmailAdresse(kontaktEmail);
  const emailIstGueltig = istGueltigeEmailAdresse(kontaktEmail);
  const emailHinweisSichtbar = emailBeruehrt && !emailIstGueltig;

  /**
   * Die einzige Stelle, die über die Absende-Sperre entscheidet. Vorher lag sie
   * in zwei nebeneinanderstehenden Effekten: einer prüfte alle Pflichtfelder,
   * der andere gab allein anhand der Kennzeichen-Auswahl frei — und beide
   * schrieben in denselben Zustand. Welcher gewann, hing an der Bedienreihen-
   * folge. Abgeleitet statt in einen Zustand geschrieben, damit sich nichts
   * mehr gegenseitig überschreiben kann.
   */
  const cannotSave = !(
    kontaktVorname !== "" &&
    kontaktNachname !== "" &&
    fahrzeugId !== "" &&
    kilometer !== "" &&
    emailIstGueltig &&
    kategorie !== "" &&
    beschreibung !== "" &&
    checkDatenschutz === true
  );

  const changeKm = (e) => {
    let valueTmp = e.target.value;

    const numericString = valueTmp.replace(/\D/g, "");

    // Wenn der String leer ist, gib eine leere Zeichenkette zurück
    if (numericString === "") return "";

    // Wandelt die Zahl in einen Integer um
    const number = parseInt(numericString, 10);

    setKilometer(number.toLocaleString("de-DE"));
  };

  const handleSave = async () => {
    // Dieselbe Sperre, die den Button ausgraut — hier noch einmal, damit sie
    // nicht allein an einem `disabled`-Attribut hängt.
    if (!canCreateMangel || cannotSave || istAmSenden) {
      return;
    }

    // console.log("save new Mangel mit id", fahrzeugId);

    const path = "fahrzeuge/" + fahrzeugId + "/maengel";
    const docRef = collection(db, path);
    // const docRef = doc(db, "fahrzeuge");

    let data = {
      new: true,
      status: "offen",
      datumAngelegt: today,
      datumLastUpdate: today,
      kategorie: kategorie,
      kontaktName: kontaktVorname + " " + kontaktNachname,
      kontaktEmail: emailAdresse,
      kontaktTelefon: kontaktTelefon,
      priorität: 4,
      kilometer: kilometer,
      historie: [
        {
          beschreibung: beschreibung,
          nutzerkreis: "",
          datum: today,
        },
      ],
    };

    // Der Dialog bleibt offen, bis Firestore-Write, Protokoll-Eintrag und
    // Mailversand durch sind: "geschlossen" heißt ab hier auch "erledigt".
    setIstAmSenden(true);

    try {
      const doc = await addDoc(docRef, data);
      await writeToProtokoll(doc.id);
    } catch (error) {
      // Scheitert schon das Anlegen, gibt es nichts zu benachrichtigen. Dieser
      // Fall bleibt vorerst wie bisher: der Dialog schließt, der Melder erfährt
      // nichts — sichtbar wird nur der Mailfehler (#14).
      console.error("Mangel konnte nicht angelegt werden", error);
      setIstAmSenden(false);
      handleClose();
      return;
    }

    // Fahrzeug und Funkkennung wandern hier mit in die Meldung, statt später
    // erneut aus dem State gelesen zu werden: das Formular bleibt im
    // Fehlerzustand bedienbar, und eine nachträglich gewechselte Auswahl darf
    // die angezeigten Kerndaten nicht auf ein Fahrzeug umschreiben, zu dem der
    // gespeicherte Mangel nicht gehört.
    await benachrichtigeTechnik({
      mangel: data,
      kennzeichen: kennzeichen,
      kennung: kennung,
      kennungEmail: kennungEmail,
    });
  };

  /**
   * Verschickt die Benachrichtigung — und nur die. Der Mangel ist an dieser
   * Stelle bereits geschrieben, ein Wiederholungsversuch fasst ihn nie wieder
   * an, sonst entstünden Duplikate im Mängel-Bestand.
   */
  const benachrichtigeTechnik = async (meldung) => {
    setIstAmSenden(true);

    try {
      await sendeMitEinemWiederholungsversuch(meldung);
      setIstAmSenden(false);
      handleClose();
    } catch (error) {
      console.error("Benachrichtigung konnte nicht versendet werden", error);
      setIstAmSenden(false);
      setGescheiterteMeldung(meldung);
    }
  };

  /**
   * Ein zweiter Versuch nur dort, wo er etwas ändern kann: Funkloch, Timeout,
   * kurzer Serverneustart. Bei 400 und 401 scheitert er identisch — dann lieber
   * sofort in den Fehlerzustand, statt den Melder warten zu lassen.
   */
  const sendeMitEinemWiederholungsversuch = async (meldung) => {
    try {
      await sendNotifyEmail(meldung);
    } catch (error) {
      if (!istWiederholbar(error)) {
        throw error;
      }
      await sendNotifyEmail(meldung);
    }
  };

  const istWiederholbar = (error) => {
    const status = error?.response?.status;

    if (status !== undefined) {
      return status >= 500;
    }

    // Anfrage raus, keine Antwort zurück: Funkloch oder Timeout. Fehlt auch die
    // Anfrage, war es kein Transportproblem, sondern ein Fehler im Client —
    // den zu wiederholen bringt nichts.
    return error?.request !== undefined;
  };

  const writeToProtokoll = (id) => {
    const path = "fahrzeuge/" + fahrzeugId + "/protokoll";
    const docRef = collection(db, path);

    let data = {
      status: "neu",
      kategorie: kategorie,
      kontaktName: kontaktVorname + " " + kontaktNachname,
      priorität: 4,
      kilometer: kilometer,
      beschreibung: beschreibung,
      nutzerkreis: "",
      datum: today,
      mangelId: id,
    };

    return addDoc(docRef, data);
  };

  const handleClose = () => {
    setFahrzeugId("");
    setGescheiterteMeldung(null);
    setEmailBeruehrt(false);
    props.close();
  };

  const prioToText = (prio) => {
    switch (prio) {
      case "1":
      case 1:
        return "Hoch";
      case "2":
      case 2:
        return "Mittel";
      case "3":
      case 3:
        return "Niedrig";
      default:
        return "Ohne";
    }
  };

  const sendNotifyEmail = ({mangel, kennzeichen, kennung, kennungEmail}) => {
    const emailData = {
      email: mangel.kontaktEmail,
      emailTo: process.env.REACT_APP_EMAIL_MANGEL_TO,
      emailCC: kennungEmail,
      kennzeichen: kennzeichen,
      kennung: kennung,
      beschreibung: mangel.historie[0].beschreibung,
      kilometerstand: mangel.kilometer,
      timestamp: Date.now(),
      telefon: mangel.kontaktTelefon,
      kontaktName: mangel.kontaktName,
      prio: prioToText(mangel.prio),
      kategorie: mangel.kategorie,
    };

    // Kein `.catch()` hier: ein verschluckter Fehler hat den Ausfall über 14
    // Monate unsichtbar gehalten. Wer sendet, behandelt den Fehlschlag auch.
    return axios.post(
      process.env.REACT_APP_EMAIL_ENDPOINT_MANGELNEU,
      emailData,
      {
        headers: {
          "x-api-key": process.env.REACT_APP_EMAIL_SERVER_API_KEY,
        },
      },
    );
  };

  const handleCheckDatenschutz = (e) => {
    let result = false;
    if (e.target.value === false || e.target.value === "false") {
      result = true;
    } else {
      result = false;
    }

    setCheckDatenschutz(result);
  };

  // Was der Melder im Fehlerzustand liest: am Telefon vorlesbar, in eine
  // selbst geschriebene Mail kopierbar, und zugleich der Beleg, dass der
  // Mangel wirklich gespeichert ist.
  const fehlerKerndaten = gescheiterteMeldung
    ? kerndaten(gescheiterteMeldung)
    : null;

  return (
    <>
      {/*
        Während des Sendens sind alle Schließwege dicht — Kreuz, Escape und
        Klick auf den Hintergrund genauso wie die beiden Buttons. Sonst wäre der
        Dialog trotz laufendem Speichern wieder weg.
      */}
      <Modal
        show={props.showModal}
        onHide={handleClose}
        backdrop={istAmSenden ? "static" : true}
        keyboard={!istAmSenden}
      >
        <Modal.Header closeButton={!istAmSenden}>
          <Modal.Title>Mangel an Fahrzeug melden</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Container>
            <Form>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Kennzeichen</Form.Label>
                    <Form.Select
                      name="modalstatus"
                      dataLiveSearch
                      onChange={(e) => {
                        setFahrzeugId(e.target.value);
                      }}
                    >
                      <option value={""}>Bitte wählen...</option>
                      {kennzeichenList.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.kennzeichen}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Kilometerstand</Form.Label>
                    <Form.Control
                      type="text"
                      id="inputKilomter"
                      value={kilometer}
                      onChange={(e) => {
                        changeKm(e);
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Vorname</Form.Label>
                    <Form.Control
                      type="text"
                      id="inputVorname"
                      value={kontaktVorname}
                      onChange={(e) => {
                        setKontaktVorname(e.target.value);
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Nachname</Form.Label>
                    <Form.Control
                      type="text"
                      id="inputNachname"
                      value={kontaktNachname}
                      onChange={(e) => {
                        setKontaktNachname(e.target.value);
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>E-Mail</Form.Label>
                    {/*
                      `type="email"` allein wegen der Bildschirmtastatur auf
                      Mobilgeräten. Die browsereigene Prüfung übernimmt hier
                      nichts: der Dialog löst kein natives Absenden aus, und
                      ihre Regel wäre schwächer — sie ließe Adressen ohne Punkt
                      durch.
                    */}
                    <Form.Control
                      type="email"
                      id="inputEmail"
                      value={kontaktEmail}
                      onChange={(e) => {
                        setKontaktEmail(e.target.value);
                      }}
                      onBlur={() => {
                        setEmailBeruehrt(true);
                      }}
                      isInvalid={emailHinweisSichtbar}
                    />
                    {/*
                      Der Hinweis steht nur im Dokument, solange er gilt.
                      Bootstrap blendet ihn sonst per CSS aus — für einen
                      Screenreader bliebe er damit trotzdem lesbar.
                    */}
                    {emailHinweisSichtbar && (
                      <Form.Control.Feedback type="invalid">
                        {EMAIL_HINWEIS}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Telefon</Form.Label>
                    <Form.Control
                      type="text"
                      id="inputTelefon"
                      value={kontaktTelefon}
                      onChange={(e) => {
                        setKontaktTelefon(e.target.value);
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Kategorie des Mangels</Form.Label>
                    <Form.Select
                      name="modalstatus"
                      value={kategorie}
                      onChange={(e) => {
                        setKategorie(e.target.value);
                      }}
                    >
                      <option value="">Bitte wählen...</option>
                      {props.kategorien.map((kategorie) => {
                        return (
                          <option
                            value={kategorie.bezeichnung}
                            key={kategorie.id}
                          >
                            {kategorie.bezeichnung}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Mangelbeschreibung</Form.Label>
                    <Form.Control
                      as="textarea"
                      style={{height: "150px"}}
                      onChange={(e) => {
                        setBeschreibung(e.target.value);
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Check
                    inline
                    type="checkbox"
                    id={`default-checkbox`}
                    checked={checkDatenschutz}
                    value={checkDatenschutz}
                    onChange={(e) => {
                      handleCheckDatenschutz(e);
                    }}
                  />{" "}
                  Ich habe die{" "}
                  <a href="/datenschutz.html" target="_blank">
                    Datenschutzerklärung
                  </a>{" "}
                  gelesen und akzeptiert.
                </Col>
              </Row>
            </Form>
          </Container>
        </Modal.Body>

        {/*
          Im Fehlerzustand bleibt der Dialog offen und zeigt den Fehlschlag
          inline — der Melder hat das Gerät noch in der Hand. "Meldung
          abschicken" verschwindet dabei: der Mangel ist längst geschrieben, ein
          zweites Abschicken würde ihn nur doppeln. Was bleibt, sind die beiden
          Wege zur Technik im Alert — und das Schließen als einziger Ausgang.
        */}
        <Modal.Footer className="flex-column align-items-stretch">
          {gescheiterteMeldung && !istAmSenden && (
            <Alert variant="danger" className="mb-0">
              <Alert.Heading as="h5">
                Mangel gespeichert — Technik nicht benachrichtigt
              </Alert.Heading>
              <p>
                Der Mangel wurde gespeichert und geht nicht verloren. Die
                automatische Benachrichtigung der Technik konnte jedoch nicht
                zugestellt werden.
              </p>
              <p className="fw-bold">
                Bitte den Mangel zusätzlich direkt an die Technik melden — sonst
                bleibt er dort unbemerkt.
              </p>
              {/*
                Der Eskalationsblock nennt zwei Kanäle, die auf jedem Gerät
                ohne Vorbedingung funktionieren — und keinen, der stillschweigend
                versagen kann. Der frühere Button, der eine vorbefüllte Mail im
                lokalen Mailprogramm öffnete, ist ersatzlos weg: auf einem Handy
                ohne eingerichtetes Mailkonto tat er beim Antippen sichtbar
                nichts, und der Melder hatte keinen Grund anzunehmen, dass er
                noch etwas tun muss. Telefon zuerst, weil es am Fahrzeug der
                schnellere und realistischere Weg ist.

                Die Nummer ist zugleich der Linktext — dadurch bleibt sie
                ablesbar, auch wo `tel:` nichts bewirkt. Sie steht bewusst ohne
                Besetzzeiten da: dass sie außerhalb der Erreichbarkeit ins Leere
                führen kann, hat der PO in Kenntnis dieser Warnung entschieden
                und damit die Streichung des Telefonkanals vom 03.08.2026
                zurückgenommen (#19).
              */}
              <div className="border-top border-bottom py-2 mb-3 text-center">
                <a
                  className="d-block fs-4 fw-bold"
                  href={TECHNIK_HOTLINE.waehlbar}
                >
                  {TECHNIK_HOTLINE.anzeige}
                </a>
                <span className="fw-bold">
                  {process.env.REACT_APP_EMAIL_MANGEL_TO}
                </span>
              </div>
              <p className="mb-1 small">
                Fahrzeug: {fehlerKerndaten.kennzeichen} (Funkkennung{" "}
                {fehlerKerndaten.kennung}) · Kategorie:{" "}
                {fehlerKerndaten.kategorie} · Kilometerstand:{" "}
                {fehlerKerndaten.kilometer} · Gemeldet:{" "}
                {fehlerKerndaten.gemeldet}
              </p>
              {/*
                Eigene Zeile statt angehängt an die Aufzählung darüber: eine
                Beschreibung kann beliebig lang sein und machte die mit
                Trennzeichen aufgereihte Zeile sonst unlesbar.
              */}
              <p className="mb-0 small">
                Beschreibung: {fehlerKerndaten.beschreibung}
              </p>
            </Alert>
          )}
          <div className="d-flex align-items-center justify-content-end gap-2">
            {istAmSenden && (
              <div className="me-auto d-flex align-items-center gap-2">
                <Spinner animation="border" size="sm" role="status" />
                <span>
                  Mangel wird gespeichert und die Technik benachrichtigt …
                </span>
              </div>
            )}
            <Button
              variant="secondary"
              onClick={handleClose}
              disabled={istAmSenden}
            >
              {/*
                Im Fehlerzustand gibt es nichts mehr abzubrechen — der Mangel
                ist geschrieben. "Abbrechen" würde dort das Gegenteil dessen
                nahelegen, was der Text gerade zusichert.
              */}
              {gescheiterteMeldung ? "Schließen" : "Abbrechen"}
            </Button>
            {!gescheiterteMeldung && (
              <Button
                variant="primary"
                onClick={handleSave}
                disabled={!canCreateMangel || cannotSave || istAmSenden}
              >
                Meldung abschicken
              </Button>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalMangel;
